module.exports = __webpack_public_path__ + "static/media/vejaodo.c2fd7607.wav";